<template>
  <pull-refresh
    style="min-height: 100vh"
    v-model="isLoading"
    @refresh="onRefresh"
  >
    <div>
      <div class="top" v-if="show">
        <div class="img">
          <img :src="img" />
        </div>
        <div>
          <div class="nickname">昵称：{{ nickname }}</div>
        </div>
      </div>
      <div class="masg" v-if="isoutshow">
        <span>
          当前无可出闸车辆信息，请重新识别车牌或录入无牌车辆信息
        </span>
      </div>
      <div class="list" v-if="show">
        <div class="item">
          <div class="left">停车场：</div>
          <div class="right">{{ detail.lot_name }}</div>
        </div>
        <div class="item">
          <div class="left">设备：</div>
          <div class="right">{{ detail.device_name }}</div>
        </div>
      </div>
      <div class="list" v-if="show">
        <div class="item">
          <div class="left">车牌号：</div>
          <div class="right">{{ detail.car_no }}</div>
        </div>
        <div class="item">
          <div class="left">入场时间：</div>
          <div class="right">{{ detail.starttime }}</div>
        </div>
        <div class="item">
          <div class="left">出场时间：</div>
          <div class="right">{{ detail.endtime }}</div>
        </div>
        <div class="item">
          <div class="left">停车时间：</div>
          <div class="right">{{ detail.use_time }}</div>
        </div>
      </div>
      <div class="tips" v-if="show">
        <div class="title">温馨提示：</div>
        <div class="content">支付后即可开杆，请确定离场时使用。</div>
      </div>
      <div class="bottom" v-if="show">
        <div class="box">
          <div class="left">
            <span class="title">总价：</span>
            <span class="price">￥{{ detail.total_price }}</span>
          </div>
          <div
            v-if="detail.is_unlicensed_out === 1"
            class="right"
            @click.stop="onOpen"
          >
            开闸
          </div>

          <div v-else class="right" @click.stop="payment">
            {{ detail.is_out === 1 ? '已出闸' : '缴费' }}
          </div>
        </div>
      </div>
      <!-- <div class="button" @click="toUnlicensed">
        <div>无牌车辆订单</div>
        <div class="right_">>></div>
      </div> -->
    </div>
  </pull-refresh>
</template>

<script>
import { getusersListjieshun, paymentjieshun, openjieshun } from '../api/api';
import { Tag, Button, Toast, PullRefresh } from 'vant';
import { mapGetters } from 'vuex';
import 'vant/lib/button/style';
export default {
  name: 'Home',
  components: {
    // Tag,
    PullRefresh,
  },
  data() {
    return {
      detail: {},
      isoutshow: false,
      show: true,
      isLoading: false,
      img: '',
      nickname: '',
      wx_zfb: '',
      user_id: undefined,
      openid: undefined,
      usersList: [],
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.img = this.userInfo.img;
    this.nickname = this.userInfo.nickname;
    this.wx_zfb = this.userInfo.wx_zfb;
    if (this.wx_zfb === 'zfb') {
      this.user_id = this.userInfo.user_id;
    } else if (this.wx_zfb === 'wx') {
      this.openid = this.userInfo.openid;
    }
    this.List();
  },
  methods: {
    async payment() {
      if (this.detail.is_out === 0) {
        try {
          let value = {};
          this.wx_zfb === 'wx'
            ? (value = {
                ...value,
                oid: this.detail.id,
                openid: this.openid,
                wx_zfb: this.wx_zfb,
              })
            : (value = {
                ...value,
                oid: this.detail.id,
                user_id: this.user_id,
                wx_zfb: this.wx_zfb,
              });
          const { data } = await paymentjieshun({ ...value });
          if (data.link_url) {
            window.location.href = data.link_url;
          } else {
            this.pay(data);
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    pay(data) {
      let that = this;
      console.log(data);
      if ('WeixinJSBridge' in window) {
        return new Promise((resolve, reject) => {
          // eslint-disable-next-line
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            { ...data, debug: true },
            function(res) {
              if (
                res.err_msg === 'get_brand_wcpay_request:ok' ||
                res.err_msg === 'stopMonitoringBeacons:ok'
              ) {
                resolve();
                Toast('支付成功');
                that.List();
              } else {
                res.errMsg ? reject(new Error(res.errMsg)) : resolve();
              }
            }
          );
        });
        // } else {
      } else if ('AlipayJSBridge' in window) {
        // await onPayOffByAlipay(data);
        if (window.AlipayJSBridge) {
          that.onZFB(data.trade_no);
        } else {
          document.addEventListener(
            'AlipayJSBridgeReady',
            that.onZFB(data.trade_no),
            false
          );
        }
      } else {
        Toast('其他');
      }
    },
    onZFB(trade_no) {
      let that = this;
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        AlipayJSBridge.call('tradePay', { tradeNO: trade_no }, function(res) {
          if (res.resultCode === '9000') {
            resolve();
            Toast('支付成功');
            that.List();
          } else {
            reject(new Error(res.resultCode));
          }
        });
      });
    },
    onRefresh() {
      this.List();
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
      }, 1000);
    },
    async List() {
      try {
        let value = {};
        this.wx_zfb === 'zfb'
          ? (value = {
              ...value,
              user_id: this.user_id,
              wx_zfb: this.wx_zfb,
              parkCode: this.userInfo.parkCode,
              equipCode: this.userInfo.equipCode,
              plateType: 1,
            })
          : (value = {
              ...value,
              openid: this.openid,
              wx_zfb: this.wx_zfb,
              parkCode: this.userInfo.parkCode,
              equipCode: this.userInfo.equipCode,
              plateType: 1,
              // openid: 'oKyiM5a8FePARLxcS5viZjTO9Tkk',
              // wx_zfb: 'wx',
            });

        console.log(value);
        const { data } = await getusersListjieshun({ ...value });
        this.usersList = data;
        this.detail = data;

        // if (data) {
        //   this.detail = data;
        //   if (this.detail.is_out != 1) {
        //     //缴费
        //     this.show = true;
        //   } else {
        //     this.isoutshow = true;
        //   }
        // } else {
        //   this.isoutshow = true;
        // }
      } catch {}
    },
    async onOpen() {
      try {
        let value = {};
        this.wx_zfb === 'wx'
          ? (value = {
              ...value,
              id: this.detail.id,
              openid: this.openid,
              wx_zfb: this.wx_zfb,
            })
          : (value = {
              ...value,
              id: this.detail.id,
              user_id: this.user_id,
              wx_zfb: this.wx_zfb,
            });
        await openjieshun({ ...value });
        Toast('出闸成功');
        this.List();
      } catch {}
    },
    toUnlicensed() {
      this.$router.push({
        name: 'jieshununlicensed',
        params: this.usersList[1],
      });
    },
  },
};
</script>
<style scoped lang="scss">
.masg {
  margin: 50% 10px 0;
}
.page {
  height: 100%;
  background-color: #f1f1f1;
}
.unpayment {
  .title {
    margin-top: 1.85rem;
    padding: 1rem;
    text-align: left;
    background-color: #fff;
    margin-bottom: 0.1rem;
    .text {
      font-weight: 700;
    }
  }
  .order-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .card-plate {
      text-align: left;
      font-size: 1rem;
      padding-bottom: 10rpx;
    }

    .card-title {
      font-size: 0.8rem;
      color: #8b8b8b;
      padding-left: 10rpx;
    }

    .card-price {
      font-size: 1rem;
      color: #858585;
      text-align: center;
    }
  }
  .car-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .tag {
      margin-right: 0.5rem;
    }
    .del-button {
      height: 40px;
      width: 50px;
      padding: 0px 10px;
      font-size: 12px;
      margin-top: 5px;
      border-radius: 5px;
    }
  }
}
.top {
  margin-bottom: 0.5rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  .img {
    margin: 0.5rem;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  .nickname {
    font-size: 1rem;
    margin-bottom: 0.2rem;
    font-weight: 500;
  }
  .openId {
    font-size: 0.5rem;
    color: darkgoldenrod;
  }
}
.list {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  .item {
    background-color: #fff;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 2.5rem;
    text-align: left;
    .left {
      width: 5rem;
      margin-left: 0.7rem;
    }
    .right {
      color: #8a8787;
    }
  }
}
.tips {
  font-size: 0.9rem;
  text-align: left;
  background-color: #fff;
  padding: 0.5rem;
  .title {
    line-height: 2.5rem;
    height: 2.5rem;
    border-bottom: 1px solid #f1f1f1;
  }
  .content {
    line-height: 2.5rem;
    height: 2.5rem;
    color: #8a8787;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 3rem;
  line-height: 3rem;
  background-color: #fff;
  width: 100%;
  .box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .left {
      text-align: left;
      width: 60%;
      margin-left: 0.5rem;
      .title {
        font-weight: 600;
        font-size: 1rem;
      }
      .price {
        color: red;
        font-weight: 600;
        font-size: 0.9rem;
      }
    }
    .right {
      width: 40%;
      background-color: #d0ad65;
      font-weight: 600;
      font-size: 1rem;
      color: #5d5128;
    }
  }
}
.button {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 54px;
  height: 45px;
  background: #d0ad65;
  color: #5d5128;
  font-weight: 600;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.right_ {
  margin-right: 20px;
}
</style>
